
export default  function tableStatusOptions() {
    return [
        'UPCOMING',
        'ACTIVE',
        'ONGOING',
        'ENDED',
        'DEACTIVATED',
    ]
}